/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ task: NonNullable<unknown>, caseNumber: NonNullable<unknown> }} Email_Task_Assigned_IntroInputs */

const en_email_task_assigned_intro = /** @type {(inputs: Email_Task_Assigned_IntroInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The task "${i?.task}" on case ${i?.caseNumber} was assigned to you.`)
};

const pt_br2_email_task_assigned_intro = /** @type {(inputs: Email_Task_Assigned_IntroInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A atividade "${i?.task}" do caso ${i?.caseNumber} foi atribuída a você.`)
};

/**
* | output |
* | --- |
* | "The task \"{task}\" on case {caseNumber} was assigned to you." |
*
* @param {Email_Task_Assigned_IntroInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const email_task_assigned_intro = /** @type {((inputs: Email_Task_Assigned_IntroInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_Task_Assigned_IntroInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_email_task_assigned_intro(inputs)
	return pt_br2_email_task_assigned_intro(inputs)
});